import { render, staticRenderFns } from "./TabSelection.vue?vue&type=template&id=1832eb3e&"
import script from "./TabSelection.vue?vue&type=script&lang=ts&"
export * from "./TabSelection.vue?vue&type=script&lang=ts&"
import style0 from "./TabSelection.vue?vue&type=style&index=0&id=1832eb3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports